// import React, { useEffect, useState } from "react";
// import BarChartView from "../../../../Components/Charts/BarChart";
// import UseGetDashBoardDataPro from "../../../../Components/Hooks/UseGetDashBoardDataPro";


// const Invoice = () => {
//   const { item, loading } = UseGetDashBoardDataPro(`/Dashboard/invoices/overview`);

//   const currentYear = new Date().getFullYear();
//     const [data, setData] = useState([]);
  
//  const [params, setParams] = useState({
//     year: currentYear,
//   });
//    const [salesData, setSalesData] = useState([]);
  
//     const years = Array.from(
//       new Array(10),
//       (val, index) => currentYear - 5 + index
//     );
//      useEffect(() => {
//         if (data && data.data) {
//           const formattedData = data.data.map((item) => ({
//             month: new Date(0, item.month - 1).toLocaleString("default", {
//               month: "short",
//             }),
//             amount: item.price,
//             monthIndex: item.month - 1,
//           }));
//           setSalesData(formattedData);
//         }
//       }, [data]);
//       const handleYearChange = (e) => {
//         const newYear = e.target.value;
//         setParams({ year: newYear });
//         setSelectedYear(newYear);
//       };
    
//   const [selectedYear, setSelectedYear] = useState(currentYear);

//   const dummyData = [
//     ];

//   return (
//     <div className="bg-white p-4 rounded-lg drop-shadow-lg h-[65vh]  2xl:h-[55vh] w-full">
    
//       <div className="flex justify-between items-center mb-4">
//         <h2 className="font-semibold text-[#4F4768] text-sm">Invoice Overview</h2>
//         <div className="flex items-center">
//           <select
//             value={selectedYear}
//             onChange={handleYearChange}
//             className="border rounded-md p-1 text-xs mb-1 text-[#ACACAC] font-normal"
//           >
//             {years.map((year) => (
//               <option key={year} value={year}>
//                 {year}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

      
//       <div className="w-full h-[300px]">
//         <BarChartView data={dummyData} />
//       </div>
//     </div>
//   );
// };

// export default Invoice;

import { useEffect, useState } from "react";
import { BarChart, LabelList, ResponsiveContainer, XAxis, YAxis, Tooltip, Legend, Bar } from "recharts";
import NuAmount from "../../../../Components/Utils/NuAmount";
import axiosInstance from "../../../../Services/axiosCommon";

const Invoice = () => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/Dashboard/invoices/overview`, { params: { year: selectedYear } });
      setData(response?.data?.invoice_overview || {});
    } catch (error) {
      console.error("Error fetching invoice data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedYear]);

  const salesData = Object.keys(data).map((month) => ({
    month: new Date(0, month - 1).toLocaleString("default", { month: "short" }),
    incoming: data[month].incoming || 0,
    outgoing: data[month].outgoing || 0,
  }));
  const renderCustomizedLabel = (props) => {
    const { x, y, width, value } = props;
    const radius = 10;
    
    if (!value) return null;

    return (
      <g>
        <text
          x={x + width / 2}
          y={y - radius}
          fill="#000"
          fontSize={10}
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {value.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </text>
      </g>
    );
  };
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload?.length) {
      return (
        <div className="bg-white drop-shadow-lg rounded-md p-2 text-[10px]">
          <p><span className="text-gray-900">{`Month : `} </span> <span className="text-gray-500">{payload[0].payload.month}</span></p>
          <p><span className="text-gray-900">Incoming: </span> <NuAmount value={payload[0].payload.incoming} /></p>
          <p><span className="text-gray-900">Outgoing: </span> <NuAmount value={payload[0].payload.outgoing} /></p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="col-span-2 bg-white h-[45vh] 2xl:h-[35vh] w-full p-4 rounded-lg drop-shadow-lg mb-4">
      <div className="flex justify-between items-center">
           <h2 className="font-semibold text-[#4F4768] text-sm">Invoice Overview</h2>

        <select
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="border rounded-md p-1 text-xs text-[#ACACAC] font-normal"
        >
          {Array.from({ length: 10 }, (_, i) => currentYear - 5 + i).map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <div className="border-t border-slate-200/60 w-full my-2"></div>

      {loading ? (
        <div className="p-4 max-w-sm w-full flex flex-col justify-center items-center h-full">
          <div className="animate-pulse flex space-x-4 w-full">
            <div className="flex-1 space-y-3 py-1">
              <div className="h-3 bg-slate-200 rounded"></div>
              <div className="space-y-3">
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-3 bg-slate-200 rounded col-span-2"></div>
                  <div className="h-3 bg-slate-200 rounded col-span-1"></div>
                </div>
                <div className="h-3 bg-slate-200 rounded"></div>
                <div className="grid grid-cols-3 gap-4">
                  <div className="h-3 bg-slate-200 rounded col-span-1"></div>
                  <div className="h-3 bg-slate-200 rounded col-span-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height="90%">
          <BarChart data={salesData}>
            <XAxis dataKey="month" fontSize={12} />
            <YAxis
  fontSize={12}
  tickFormatter={(value) =>
    value.toLocaleString('en-US', {
      maximumFractionDigits: 2,
    })
  }
/>
            <Tooltip content={<CustomTooltip />} cursor={{ fill: "none" }} />
            <Legend fontSize={8} verticalAlign="top" height={26} iconSize={12} iconType="circle" wrapperStyle={{ fontSize: '12px' }} />

            <Bar dataKey="incoming" fill="#FF2929" barSize={10} radius={[10, 10, 0, 0]}>
              {/* <LabelList dataKey="incoming" position="top" content={renderCustomizedLabel} /> */}
            </Bar>
            <Bar dataKey="outgoing" fill="#0D92F4" barSize={10} radius={[10, 10, 0, 0]}>
              {/* <LabelList dataKey="outgoing" position="top" content={renderCustomizedLabel} /> */}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default Invoice;

